import { type Category } from './product-category-nav';
import {
  NavigationMenuLink,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from './ui/navigation-menu';
import Link from 'next/link';
import { cn } from '~/lib/utils';

export function ProductCategoryNavTrigger({
  category,
}: {
  category: Category;
}) {
  const topLevelClassName = cn(
    // base
    'rounded-none bg-inherit font-bold text-inherit text-sm flex-wrap px-2 max-w-max w-auto whitespace-normal h-full leading-[1.1] min-h-9',
    // active
    'data-[active]:bg-[var(--site-header-nav-panel-background)] data-[active]:text-[var(--site-header-nav-panel-foreground)]',
    'data-[state=open]:bg-[var(--site-header-nav-panel-background)] data-[state=open]:text-[var(--site-header-nav-panel-foreground)]',
    // hover
    'hover:bg-[var(--site-header-nav-panel-background)] hover:text-[var(--site-header-nav-panel-foreground)]',
    // focus
    'focus:bg-[var(--site-header-nav-item-focus-background)] focus:text-[var(--site-header-nav-item-focus-foreground)]',
    // open/active
    ' data-[state=open]:bg-[var(--site-header-nav-panel-background)] data-[state=open]:text-[var(--site-header-nav-panel-foreground)]',
  );

  if (!category.subcategories || category.subcategories.length === 0) {
    return (
      <NavigationMenuLink
        asChild
        className={cn(navigationMenuTriggerStyle(), topLevelClassName)}
      >
        <Link href={category.href}>{category.name}</Link>
      </NavigationMenuLink>
    );
  }

  return (
    <Link href={category.href} tabIndex={-1}>
      <NavigationMenuTrigger
        className={cn(navigationMenuTriggerStyle(), topLevelClassName)}
      >
        {category.name}
      </NavigationMenuTrigger>
    </Link>
  );
}
